// custom enums
import { Contract_Type } from "../../enums/ads/contract-types";

export const ListOfContractType = [
    {name: 'بيع', id: Contract_Type.SE},
    {name: 'تاجير', id: Contract_Type.RT},
  ]